// Styles
import cn from '../../../../utils/cn';
import styles from './EnumCell.module.css';
import commonStyles from '../TableCellCommon.module.css';

/**
 * Enum cell component for table display with dropdown selection
 * @param {object} props
 * @param {string} props.value - Current selected value
 * @param {string} [props.className] - Additional CSS classes
 * @param {boolean} [props.disabled=false] - Whether the component is disabled
 * @param {boolean} [props.bold] - Text in bold
 * @param {boolean} [props.italic] - Text in italic
 * @param {boolean} [props.strikeThrough] - Text with strike-through
 * @param {boolean} [props.underline] - Text underlined
 * @param {Align} [props.align] - Text alignment
 * @param {VerticalAlign} [props.verticalAlign='middle'] - Vertical alignment
 * @returns {JSX.Element}
 */
function EnumCell({
  value,
  className = '',
  disabled = false,
  bold = false,
  italic = false,
  strikeThrough = false,
  underline = false,
  align = 'left',
  verticalAlign = 'middle',
}) {
  return (
    <div
      className={cn([
        styles['enum-cell'],
        className,
        bold && commonStyles['cell-bold'],
        italic && commonStyles['cell-italic'],
        strikeThrough && commonStyles['cell-strike-through'],
        underline && commonStyles['cell-underline'],
        align && commonStyles[`cell-align-${align}`],
        verticalAlign && commonStyles[`cell-vertical-align-${verticalAlign}`],
      ])}
    >
      <div className={cn([styles['enum-group'], disabled && styles['enum-group-disabled']])}>
        {value}
      </div>
    </div>
  );
}

export default EnumCell;
